import React from 'react';
import style from './FormInput.module.css';

const FormInput = ({
	HeadingText,
	placeholder,
	change,
	onEnter,
	width,
	value,
	type = 'text',
	disabled = false,
	showIsEmpty: _showIsEmpty,
}) => {
	const handleKeyDown = (event) => {
		if (event.key === 'Enter' && onEnter) {
			onEnter(event);
		}
	};

	const inputStyle = width ? { width } : undefined;

	return (
		<div className={style.FormInputWrapper}>
			{HeadingText && (
				<span className={style.QuestionHeading}>{HeadingText}</span>
			)}
			<input
				type={type}
				className={style.FormTextInput}
				onChange={change}
				onKeyDown={handleKeyDown}
				placeholder={placeholder}
				value={value}
				disabled={disabled}
				style={inputStyle}
			/>
		</div>
	);
};

export default FormInput;
